import { render, staticRenderFns } from "./accountsList.vue?vue&type=template&id=5f99aaaa&scoped=true"
import script from "./accountsList.vue?vue&type=script&lang=js"
export * from "./accountsList.vue?vue&type=script&lang=js"
import style0 from "./accountsList.vue?vue&type=style&index=0&id=5f99aaaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f99aaaa",
  null
  
)

export default component.exports